module.exports = __webpack_public_path__ + "assets/img/woman_searches.2be5890f.svg";